export const GET_CRM_CUSTOMER = '/account/getcrmcustomer';
